import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import FooterLink from '@/Fi16100/Components/FooterLink.jsx';
import {usePage} from '@inertiajs/react';
import {I18nContext} from 'react-i18next';

function FooterLinks(props) {
	const t = useContext(I18nContext).i18n.t;
	const businessSiteOrigin = String(usePage().props.businessSiteOrigin);
	const columnClassName = 'w-auto col px-3 mb-3';

	return (
		<div className={(props.className ?? '') + ' container d-flex justify-content-center'}>
			<div className="row d-inline-block d-md-flex justify-content-md-center pt-2">
				<div className="w-auto d-xl-flex flex-row">
					<div className={columnClassName}>
						<FooterLink href={route('fi16100.sms')} header={true}>
							{t('footer.sms.header')}
						</FooterLink>

						<FooterLink href={route('fi16100.sms') + '#numerohaku'}>
							{t('footer.sms.number')}
						</FooterLink>

						<FooterLink href={route('fi16100.sms') + '#nimihaku'}>
							{t('footer.sms.name')}
						</FooterLink>

						<FooterLink href={route('fi16100.sms') + '#osoitehaku'}>
							{t('footer.sms.address')}
						</FooterLink>

						<FooterLink href={route('fi16100.sms') + '#ajoneuvotietojen-haku'}>
							{t('footer.sms.vehicles')}
						</FooterLink>
					</div>

					<div className={columnClassName}>
						<FooterLink href={route('fi16100.calls')} header={true}>
							{t('footer.calls.header')}
						</FooterLink>

						<FooterLink href={route('fi16100.calls')}>
							{t('footer.calls.calls')}
						</FooterLink>

						<FooterLink href={route('fi16100.calls-03003000')}>
							{t('footer.calls.calls03003000')}
						</FooterLink>
					</div>

					<div className={columnClassName}>
						<FooterLink href={route('fi16100.vehicles')} header={true}>
							{t('footer.vehicles.header')}
						</FooterLink>

						<FooterLink href={route('fi16100.vehicles')}>
							{t('footer.vehicles.web')}
						</FooterLink>

						<FooterLink href={route('fi16100.sms') + '#ajoneuvotietojen-haku'}>
							{t('footer.vehicles.sms')}
						</FooterLink>
					</div>
				</div>

				<div className="w-auto d-xl-flex flex-row">
					<div className={columnClassName}>
						<FooterLink href={businessSiteOrigin + '/'} header={true} external={true}>
							{t('footer.businesses.header')}
						</FooterLink>

						<FooterLink href={businessSiteOrigin + '/id16100'} external={true}>
							{t('footer.businesses.id1600')}
						</FooterLink>

						<FooterLink href={businessSiteOrigin + '/connect'} external={true}>
							{t('footer.businesses.connect')}
						</FooterLink>

						<FooterLink href={businessSiteOrigin + '/numeropalvelu'} external={true}>
							{t('footer.businesses.nupa')}
						</FooterLink>

						<FooterLink href={businessSiteOrigin + '/ajoneuvotiedot'} external={true}>
							{t('footer.businesses.vehicles')}
						</FooterLink>

						<FooterLink href={businessSiteOrigin + '/vaihdepalvelu'} external={true}>
							{t('footer.businesses.vhp')}
						</FooterLink>

						<FooterLink href={businessSiteOrigin + '/rajapinnat'} external={true}>
							{t('footer.businesses.api')}
						</FooterLink>
					</div>

					<div className={columnClassName}>
						<FooterLink href={route('fi16100.vehicles')} header={true}>
							{t('footer.company.header')}
						</FooterLink>

						<FooterLink href={route('fi16100.company') + '#yhteystiedot'}>
							{t('footer.company.contactInfo')}
						</FooterLink>

						<FooterLink href={route('fi16100.contact')}>
							{t('footer.company.contact')}
						</FooterLink>
					</div>
				</div>
			</div>
		</div>
	);
}

FooterLinks.propTypes = {
	className: PropTypes.string,
};

export default FooterLinks;
